export interface BatchReserveContactMailSendRequest {
  dateFrom: string
  dateTo: string
  userRegistrationBranchCode: string
  receiveBranchCode: string
  isSendContacted: boolean
  sendFromBranchCode: string
  ids: string[]
}

export function BatchReserveContactMailSendRequestToJSON(
  value: BatchReserveContactMailSendRequest
): any {
  return {
    date_from: value.dateFrom,
    date_to: value.dateTo,
    user_registration_branch_code: value.userRegistrationBranchCode,
    receive_branch_code: value.receiveBranchCode,
    is_send_contacted: value.isSendContacted,
    send_from_branch_code:
      value.sendFromBranchCode !== '' ? value.sendFromBranchCode : undefined,
    ids: value.ids.length > 0 ? value.ids : undefined
  }
}
